/**
 * Promotion Engine for Maison Store
 * Handles logic for calculating eligible items and discount tiers based on cart data.
 */

window.PromotionEngine = {
  config: window.PromotionEngineConfig || {
    name: "<b>Celebration</b> Sale",
    itemLabel: "item",
    enableToast: true,
    enableCartBar: true,
    tiers: [
      { quantity: 1, discount: 10 },
      { quantity: 2, discount: 20 },
      { quantity: 3, discount: 30 },
      { quantity: 4, discount: 40 } // max tier
    ],
    eligibilityRules: {
      type: "all",
      value: ""
    }
  },

  setConfig(config) {
    this.config = { ...this.config, ...config };
    this.config.tiers.sort((a, b) => a.quantity - b.quantity);
  },

  getMaxQuantity() {
    return this.config.tiers[this.config.tiers.length - 1].quantity;
  },

  isEligible(item) {
    if (!this.config.eligibilityRules) return true;

    if (this.config.eligibilityRules.type === 'all') return true;

    if (this.config.eligibilityRules.type === 'product_type') {
      const type = (item.product_type || '').toLowerCase();
      const matchValue = (this.config.eligibilityRules.value || '').toLowerCase();
      return type.includes(matchValue) || (item.title && item.title.toLowerCase().includes(matchValue));
    }

    if (this.config.eligibilityRules.type === 'tag') {
      // Tags might not be in all cart item payloads, but if available:
      return item.tags && item.tags.includes(this.config.eligibilityRules.value);
    }

    return true;
  },

  getEligibleQuantity(cartData) {
    if (!cartData || !cartData.items) return 0;

    return cartData.items.reduce((total, item) => {
      if (this.isEligible(item)) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  },

  getPromotionState(cartData) {
    const eligibleQty = this.getEligibleQuantity(cartData);
    let currentTier = null;
    let nextTier = this.config.tiers[0];

    for (let i = 0; i < this.config.tiers.length; i++) {
      if (eligibleQty >= this.config.tiers[i].quantity) {
        currentTier = this.config.tiers[i];
        nextTier = this.config.tiers[i + 1] || null;
      } else {
        break;
      }
    }

    const maxTier = this.config.tiers[this.config.tiers.length - 1];
    const isMax = currentTier && currentTier.quantity >= maxTier.quantity;

    const remainingQuantity = nextTier ? nextTier.quantity - eligibleQty : 0;

    // Calculate progress as a percentage
    let progress = 0;
    if (isMax) {
      progress = 100;
    } else if (nextTier) {
      // Simple linear progress based on max tier
      progress = (eligibleQty / maxTier.quantity) * 100;
    }

    return {
      eligibleQuantity: eligibleQty,
      currentTier,
      nextTier,
      isMax,
      remainingQuantity,
      progress,
      maxQuantity: maxTier.quantity
    };
  },

  getMessage(state, itemLabel = "item") {
    let titleStr = this.config.messages?.barTitle || "{discount}% OFF UNLOCKED!";
    let subtitleStr = this.config.messages?.barSubtitle || "Add {quantity} more {item} to unlock {discount}% OFF";
    
    let currentDisc = state.currentTier ? state.currentTier.discount : 0;
    let nextDisc = state.nextTier ? state.nextTier.discount : currentDisc;
    
    if (state.isMax) {
      return {
        title: `✦ ` + titleStr.replace(/{discount}/g, state.currentTier.discount),
        subtitle: `You've unlocked our maximum ${this.config.name} discount!`
      };
    }

    if (state.currentTier) {
      return {
        title: `✦ ` + titleStr.replace(/{discount}/g, state.currentTier.discount),
        subtitle: subtitleStr
          .replace(/{quantity}/g, state.remainingQuantity)
          .replace(/{item}/g, itemLabel)
          .replace(/{discount}/g, state.nextTier.discount)
      };
    }

    return {
      title: this.config.name.toUpperCase(),
      subtitle: subtitleStr
        .replace(/{quantity}/g, state.remainingQuantity)
        .replace(/{item}/g, itemLabel)
        .replace(/{discount}/g, state.nextTier.discount)
    };
  }
};
